import styled, { css } from 'styled-components';
import { Theme } from '@getgrover/ui';
import { StickyHeader } from '@devsbb/header-ui';
import { WithTransparentHeader } from './types';

const handleBackgroundColor = ({
    theme,
    withTransparentHeader,
    isMobile,
}: {
    theme: Theme;
    isMobile?: boolean;
} & WithTransparentHeader): string => {
    if (withTransparentHeader) return 'transparent';
    if (isMobile) return `linear-gradient(${theme.colors.Background} 80%, transparent 20%)`;
    return `linear-gradient(${theme.colors.Background} 70%, transparent 30%)`;
};

export const HeaderWrapper = styled(StickyHeader)<
    {
        mobile: boolean;
        isHeaderV2Enabled: boolean;
        hideHalfHeader?: boolean;
    } & WithTransparentHeader
>`
    width: 100%;
    max-width: 1600px;
    margin: auto;

    ${({ isHeaderV2Enabled }) => !isHeaderV2Enabled && `padding: 12px 16px 0px;`};

    @media (${({ theme }) => theme.screens.desktop}) {
        padding: 0 72px;
    }
`;

export const LoaderWrapper = styled.div`
    max-width: 1600px;
    margin: auto;
    padding: 12px 16px 0px;
    @media (${({ theme }) => theme.screens.desktop}) {
        padding: 0 72px;
    }
`;
